import React from 'react';
import { LoadingContextProvider } from '@app/Context/LoadingContextProvider';
import { GlobalLoader } from '@app/Components/Loader/GlobalLoader/GlobalLoader';
import { LoadingContext } from '@app/Context/LoadingContext';
export var GlobalLoaderWrapper = function (props) { return (React.createElement(LoadingContextProvider, null,
    React.createElement(LoadingContext.Consumer, null, function (context) { return (React.createElement(React.Fragment, null,
        React.createElement(GlobalLoader, { loading: context.loading }),
        props.children)); }))); };
